import React from 'react'

type HeatIconProps = {
  color?: string
  width?: string
  height?: string
  fill?: string
}

function HeartIcon({
  color = '#6267AC',
  width = '32',
  height = '32',
  fill = '',
}: HeatIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.4259 8.5C22.3611 8.5 24.3333 11.2938 24.3333 13.9C24.3333 19.1781 16.1482 23.5 16 23.5C15.8519 23.5 7.66667 19.1781 7.66667 13.9C7.66667 11.2938 9.63889 8.5 12.5741 8.5C14.2593 8.5 15.3611 9.35312 16 10.1031C16.6389 9.35312 17.7407 8.5 19.4259 8.5Z'
        stroke={color}
        fill={fill}
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default HeartIcon
